var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialLinkedin18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.85 4.428A1.43 1.43 0 0 0 4.426 3 1.43 1.43 0 0 0 3 4.428c0 .784.642 1.427 1.425 1.427.784 0 1.426-.643 1.426-1.427zM5.709 15H3.213V7h2.495v8zm3.95-7.93H7.235V15H9.73V11.07C9.73 10 9.944 9 11.225 9c1.282 0 1.282 1.214 1.282 2.143V15H15v-4.357c0-2.143-.499-3.785-2.992-3.785-1.21 0-1.994.642-2.35 1.285V7.07z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTUuODUgNC40MjhBMS40MyAxLjQzIDAgMCAwIDQuNDI2IDMgMS40MyAxLjQzIDAgMCAwIDMgNC40MjhjMCAuNzg0LjY0MiAxLjQyNyAxLjQyNSAxLjQyNy43ODQgMCAxLjQyNi0uNjQzIDEuNDI2LTEuNDI3ek01LjcwOSAxNUgzLjIxM1Y3aDIuNDk1djh6bTMuOTUtNy45M0g3LjIzNVYxNUg5LjczVjExLjA3QzkuNzMgMTAgOS45NDQgOSAxMS4yMjUgOWMxLjI4MiAwIDEuMjgyIDEuMjE0IDEuMjgyIDIuMTQzVjE1SDE1di00LjM1N2MwLTIuMTQzLS40OTktMy43ODUtMi45OTItMy43ODUtMS4yMSAwLTEuOTk0LjY0Mi0yLjM1IDEuMjg1VjcuMDd6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export { SvgSocialLinkedin18 as ReactComponent };